import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { purchase } from '../intents/intentLinks';
import { getCurrencyCode, getDtbId } from '../store/pricing/selectors';
export const getAcq129PurchaseCrmSuiteStarterRedirect = state => {
  const currencyCode = getCurrencyCode(state);
  const dtbId = getDtbId(state);
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  return purchase(portalId, hublet, {
    currency: currencyCode,
    dtbId: dtbId
  });
};